import React, { useState } from "react";
import { Button } from "@mui/material";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../components/Button";
import { useModal } from "../../../components/modal";
import { CustomTextField } from "../../../components/TextFields";
import FileUploader from "../../../components/uploader/fileUploader";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import objToFromData from "../../../utils/objToFromdata";
import {
  useAddCourseFileMutation,
  useUpdateCourseFileMutation,
} from "../../../app/services/files.api";
import { CourseFile } from "../../../types/files";
import LoadingButton from "../../../components/Button/LoadingButton";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  desc: yup.string(),
});

export default function AddModal({
  courseId,
  file: defaultValue,
}: {
  courseId: string;
  file?: CourseFile;
}) {
  const { setShow } = useModal();
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValue
      ? { title: defaultValue.title, desc: defaultValue?.desc }
      : {},
  });
  const [file, setFile] = useState<File | null>(null);
  const [addFile, addState] = useAddCourseFileMutation();
  const [updateFile, updateState] = useUpdateCourseFileMutation();

  return (
    <React.Fragment>
      <CustomTextField
        variant="outlined"
        placeholder="عنوان را وارد کنید."
        label="عنوان"
        required
        onChange={(e) => setValue("title", e.target.value)}
        defaultValue={getValues("title")}
        error={!!errors.title}
        helperText={errors.title?.message}
      />
      <CustomTextField
        variant="outlined"
        placeholder="توضیحات را وارد کنید."
        label="توضیحات"
        onChange={(e) => setValue("desc", e.target.value)}
        error={!!errors.desc}
        helperText={errors.desc?.message}
        defaultValue={getValues("desc")}
        multiline
        minRows={2}
        maxRows={4}
      />
      <FileUploader required onChange={(e) => setFile(e)} />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading || updateState.isLoading}
          onClick={handleSubmit((data) => {
            const isEdit = !!defaultValue;
            if (!file && !isEdit) return;
            const formData = objToFromData(data);
            if (file) formData.append("file", file);

            if (isEdit) {
              return updateFile({
                courseId,
                fileId: defaultValue?._id,
                data: formData,
              })
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }

            addFile({ courseId, data: formData })
              .unwrap()
              .then(() => {
                setShow(false);
              })
              .catch((err) => {});
          })}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
